"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JourneyParser = void 0;
var _constants = require("../../constants");
class JourneyParser {
  constructor(_ref) {
    let {
      handsetsAndPlansJourneyName,
      handsetJourneyName,
      planJourneyName,
      flags,
      currentQuestion
    } = _ref;
    this.handsetsAndPlansJourneyName = void 0;
    this.planJourneyName = void 0;
    this.handsetJourneyName = void 0;
    this.flags = void 0;
    this.currentQuestion = void 0;
    this.handsetsAndPlansJourneyName = handsetsAndPlansJourneyName;
    this.planJourneyName = planJourneyName;
    this.handsetJourneyName = handsetJourneyName;
    this.flags = flags;
    this.currentQuestion = currentQuestion;
  }
  getNameOfJourney() {
    var _this$flags, _this$flags2;
    if ((_this$flags = this.flags) !== null && _this$flags !== void 0 && _this$flags['both-flow']) {
      return this.handsetsAndPlansJourneyName;
    }
    if ((_this$flags2 = this.flags) !== null && _this$flags2 !== void 0 && _this$flags2.plan) {
      return this.planJourneyName;
    }
    return this.handsetJourneyName;
  }
}
exports.JourneyParser = JourneyParser;